import { getSummaryDashboard } from '@apis'
import { useQuery } from '@tanstack/react-query'
import { BaseResponseSPCG, SummaryDashboard } from '@types'
import { AxiosResponse } from 'axios'

import { adminDashboardQueryKeys } from './adminDashboardQueryKeys'

const ONE_HOUR = 1000 * 60 * 60

const useGetAdminDashboard = (dashboardId: string) => {
  return useQuery({
    queryFn: () => getSummaryDashboard(dashboardId),
    queryKey: adminDashboardQueryKeys.detail(dashboardId),
    select: (response: AxiosResponse<BaseResponseSPCG<SummaryDashboard>>) => response.data.result,
    staleTime: ONE_HOUR,
    refetchInterval: ONE_HOUR,
  })
}

export default useGetAdminDashboard
